<template>
  <v-container fluid>
    <bodyswaps-appbar app />
    <bodyswaps-navigation />
    <v-main>
      <router-view />
    </v-main>
  </v-container>
</template>

<script>
  // import firebase from 'firebase/app'
  import 'firebase/auth'
  // import router from '@/router'
  import Navigation from './Navigation.vue'
  import AppBar from './AppBar.vue'

  export default {
    name: 'DashboardIndex',


    components: {
      'bodyswaps-navigation': Navigation,
      'bodyswaps-appbar': AppBar,
    },

    data: () => ({
    }),

    mounted () {
    /*  const currentUser = firebase.auth().currentUser
      if (currentUser === null) {
        router.push('/login')
        return null
      } */
    },

  }
</script>
<style scoped>
  @media (max-width: 600px) {
  .container {
    padding: 0px;
  }}
</style>

